import { useFormContext } from "react-hook-form";
import PagamentoParcelas from "@/components/PagamentoParcelas";
import { calcularTotalMatricula } from "@/utils/totaisMatricula";

type Props = {
  current?: number;
  disabled?: boolean;
};

/**
 * Etapa "Pagamento" do cadastro do aluno. O bloco de parcelas em si é o
 * componente compartilhado com a venda avulsa; aqui só entra o que é da
 * matrícula: o total (disciplinas + produtos) e o nome do responsável usado
 * pelo botão "Copiar Responsável" do modal de cheques.
 */
function Pagamento({ disabled = false }: Props) {
  const { watch } = useFormContext<any>();

  const disciplinas = watch('disciplinas');
  const produtos = watch('produtos');
  const nomeResponsavel = watch('responsavel.pessoaResponsavel.nome');

  return (
    <>
      <div className="mb-8">
        <span className="text-white text-2xl">Pagamento</span>
      </div>
      <PagamentoParcelas
        disabled={disabled}
        valorTotal={calcularTotalMatricula(disciplinas, produtos)}
        rotuloValorTotal="Valor Total (Disciplinas + Produtos)"
        nomeParaCopiarCheque={nomeResponsavel}
        rotuloCopiarCheque="Copiar Responsável"
      />
    </>
  );
}

export default Pagamento;
